 export class DynamicFlow
    {
        public Rows : DynamicFlow_Row[];
    }
    export class DynamicFlow_Row
    {
        public Row_Heading : string;
        public Columns : DynamicFlow_Column[];
    }
    export class DynamicFlow_Column
    {       
        public Column_Heading : string;        
        public Column_Type : string;       
        public Chart_Type : string;
        public Chart_Labels : string[];

        public DataColumns_Heading : string[];      
        public DataColumns_DataSet : ChartData[];
        public DataColumns_Color   : ChartDataColors[];
        public DataColumns_DataContainsLabel : boolean;
        public Chart_Options : ChartOptions;

        public XHeading :string;
        public YHeading :string;
        public ChartColorSet :string;
        public ChartReportID: number;
        public ChartReportDuration:string;     
        
        public showChartControl : boolean = true;
        //Above, We will store, We are showing graph for Yearly,Monthly,Weekly or Daily
        //Values 20501,20502,20503,20504
    }
    export class ChartData
    {
        public data : number[];
        public dataValue : string[];
        public label : string;
        public type :string;
        public yAxisID:string;
        public backgroundColor:string;
        public borderDash: number[];
    }
    export class ChartDataColors
    {
        public  backgroundColor :string;
        public  hoverBackgroundColor : string;
        public  borderColor : string;
        public  pointBackgroundColor : string;
        public  pointBorderColor : string;
        public  pointHoverBackgroundColor: string;
        public  pointHoverBorderColor : string;
    }
    
    export class ChartCommonDataColors
    {
        public  backgroundColor :string[]; 
        public  hoverBackgroundColor : string[];
        public  borderColor : string[];
        public  pointBackgroundColor : string[];
        public  pointBorderColor : string;
        public  pointHoverBackgroundColor: string;
        public  pointHoverBorderColor : string[];
    }

    export class ListOptions
    {

    }
    export class ChartOptions
    {
        public responsive : boolean;

        // public  responsiveAnimationDuration : number;

        // public  maintainAspectRatio : boolean;

        // public  aspectRatio : number;


        // public color : string[];

        public legend : option_legend;

        public  scales: scales_yAxes;
         
        // public tooltips : option_tooltips;

    
    }
    export class option_legend
    {
        // option_legend()
        // {
        //     this.display = true;
        //     this.position = "bottom";
        // }
        public  display : boolean;
        public  position :string;
    }
    export class option_scales
    {
        public  yAxes : scales_yAxes;
    }

    export class scales_yAxes
    {
        public  ticks : yAxes_ticks;
        public display : boolean;
    }
    export class yAxes_ticks
    {
        public beginAtZero : boolean;
        // public suggestedMin : number;
        // public  steps : number;

        // public  stepValue : number;

        // public  max: number;

        // public  min : number;

        // public  stepSize : number;
    }
    export class option_tooltips
    {
        public mode : string;
        public axis : string;
    }
    export class legend_options
    {
        public title : string;
        public backgroundColor:string;
        public appliedDataIndexes : number[];
        public id  : number;
    }

    export class DynamicDashboard_DBRow
    {
        DisplayRow: number;
        Active: number;
        DisplayColumn: number;
        ReportId: number;
        UserDashboardReportId: number;
        ReportName:string;
        ReportTypeName:string;
        ReportSubTypeName:string;
        ReportType:number;
        ReportSubType:number;
        AssociatedEntityType:number;
        DisplayType:number;
        Header:string;
        Footer:string;
        Body:string;
        DisplayOrder:number;
        DataSourceID:number;
        DataSourceName:string;
        DataSourceType:number;
        DataSourceObjectName:string;
        DataSourceOutputType:number;
        DataSourceColumnList:string;
        Color:string;
        CharTypeID:number;
        ControlType:number;
        requestParams:string;
    }


// WEBPACK FOOTER //
// ./src/app/models/dashboard/dynamicDashboard.ts